<!-- JOB BOX STARTS-->
<div class="job-box bg-white mt-4">
  <div class="p-4">
    <div class="row gray">
      <div class="col-xl-9">
        <div>
          <div class="row">
            <div class="col-xl-6">
              <ngx-skeleton-loader
                count="1"
                [theme]="{ 'border-radius': '4px', height: '32px' }"
              ></ngx-skeleton-loader>
            </div>
            <div class="col-xl-4"></div>
            <div class="col-xl-2">
              <ngx-skeleton-loader
                count="1"
                [theme]="{ 'border-radius': '4px', height: '32px' }"
              ></ngx-skeleton-loader>
            </div>
          </div>
          <!-- Title -->
          <div class="row">
            <div class="col-xl-3">
              <ngx-skeleton-loader
                count="1"
                [theme]="{ 'border-radius': '4px', height: '19px' }"
              ></ngx-skeleton-loader>
            </div>
            <div class="col-xl-9"></div>
          </div>
          <div class="mb-0">
            <!-- Job Description -->
            <ngx-skeleton-loader
              count="1"
              [theme]="{ 'border-radius': '4px', height: '72px' }"
            ></ngx-skeleton-loader>
          </div>
        </div>
      </div>
      <div class="col-xl-3 details gray">
        <!-- Job Properties -->
        <ngx-skeleton-loader
          count="1"
          [theme]="{ 'border-radius': '4px', height: '155px' }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</div>
